import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/app/[locale]/online-bestellen-webshop/WebshopPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8deb9ccd66ffb00/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8deb9ccd66ffb00/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/TechPartnersSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8deb9ccd66ffb00/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8deb9ccd66ffb00/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebshopShowcase"] */ "/tmp/8deb9ccd66ffb00/components/sections/WebshopShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitCard"] */ "/tmp/8deb9ccd66ffb00/components/ui/BenefitCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PricingFactorCard"] */ "/tmp/8deb9ccd66ffb00/components/ui/PricingFactorCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
